// Erkennt bekannte Social-Media-/Community-Plattformen anhand der URL,
// damit Profile.js und FriendProfile.js Links mit Icon + lesbarem Plattformnamen anzeigen können.
import {
  SiInstagram, SiMyanimelist, SiSnapchat, SiX, SiFacebook, SiTiktok, SiDiscord,
  SiYoutube, SiReddit, SiTwitch, SiGithub, SiPixiv, SiAnilist, SiThreads,
  SiBluesky, SiTumblr, SiKofi, SiPatreon, SiMastodon, SiTelegram, SiWhatsapp,
} from 'react-icons/si';
import { FaLinkedin, FaLink } from 'react-icons/fa6';

const SOCIAL_PLATFORMS = [
  { pattern: /instagram\.com/i, label: 'Instagram', Icon: SiInstagram, color: '#E4405F' },
  { pattern: /myanimelist\.net/i, label: 'MyAnimeList', Icon: SiMyanimelist, color: '#2E51A2' },
  { pattern: /snapchat\.com/i, label: 'Snapchat', Icon: SiSnapchat, color: '#FFFC00' },
  { pattern: /(twitter\.com|x\.com)/i, label: 'X (Twitter)', Icon: SiX, color: '#000000' },
  { pattern: /facebook\.com/i, label: 'Facebook', Icon: SiFacebook, color: '#0866FF' },
  { pattern: /tiktok\.com/i, label: 'TikTok', Icon: SiTiktok, color: '#000000' },
  { pattern: /discord(\.gg|\.com)/i, label: 'Discord', Icon: SiDiscord, color: '#5865F2' },
  { pattern: /(youtube\.com|youtu\.be)/i, label: 'YouTube', Icon: SiYoutube, color: '#FF0000' },
  { pattern: /reddit\.com/i, label: 'Reddit', Icon: SiReddit, color: '#FF4500' },
  { pattern: /twitch\.tv/i, label: 'Twitch', Icon: SiTwitch, color: '#9146FF' },
  { pattern: /github\.com/i, label: 'GitHub', Icon: SiGithub, color: '#181717' },
  { pattern: /pixiv\.net/i, label: 'Pixiv', Icon: SiPixiv, color: '#0096FA' },
  { pattern: /anilist\.co/i, label: 'AniList', Icon: SiAnilist, color: '#02A9FF' },
  { pattern: /threads\.net/i, label: 'Threads', Icon: SiThreads, color: '#000000' },
  { pattern: /bsky\.app/i, label: 'Bluesky', Icon: SiBluesky, color: '#0285FF' },
  { pattern: /tumblr\.com/i, label: 'Tumblr', Icon: SiTumblr, color: '#36465D' },
  { pattern: /linkedin\.com/i, label: 'LinkedIn', Icon: FaLinkedin, color: '#0A66C2' },
  { pattern: /ko-fi\.com/i, label: 'Ko-fi', Icon: SiKofi, color: '#FF5E5B' },
  { pattern: /patreon\.com/i, label: 'Patreon', Icon: SiPatreon, color: '#FF424D' },
  { pattern: /mastodon\.[a-z]+/i, label: 'Mastodon', Icon: SiMastodon, color: '#6364FF' },
  { pattern: /telegram\.(me|org)|t\.me/i, label: 'Telegram', Icon: SiTelegram, color: '#26A5E4' },
  { pattern: /whatsapp\.com/i, label: 'WhatsApp', Icon: SiWhatsapp, color: '#25D366' },
];

// { label, Icon, color } - color ist null beim generischen Fallback (nutzt Theme-Farbe)
export const getSocialPlatform = (url) => {
  if (!url) return null;
  const match = SOCIAL_PLATFORMS.find(({ pattern }) => pattern.test(url));
  if (match) return match;

  try {
    const hostname = new URL(url).hostname.replace(/^www\./, '');
    return { label: hostname, Icon: FaLink, color: null };
  } catch (e) {
    return { label: null, Icon: FaLink, color: null };
  }
};

export const getSocialPlatformLabel = (url) => getSocialPlatform(url)?.label || null;
